//ordina un array di oggetti in base a un campo specifico
//e in base a un ordine specifico ('asc' o 'desc)
//è case insensitive, ordina in modo 'naturale' (es, test 1, TEST 2, Test 10, test 13)
export const sortByNameWithNumbers = (array: Record<string, any>, field: string, order: 'asc' | 'desc' = 'asc') => {
	if (!Array.isArray(array)) return [];

	return array.sort((a, b) => {
		const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
		return order === 'asc' ? collator.compare(a[field], b[field]) : collator.compare(b[field], a[field]);
	});
};
